export const PRIMARY = '#f20303';

export const WHITE = '#fff';

export const BLACK = '#1c1c1c';

export const PALE_GREEN = '#dddee8';
